import { takeLeading, call, put, select } from 'typed-redux-saga'
import { ResponseCatalog, RequestParams } from 'Models'
import { errorHandler, gridSlice } from 'Modules'
import { CompanyModel, companyApi, CompanyNS, companySlice, companySelectors } from 'Pages/company'

export function* getList(action: CompanyNS.GetCompanyList) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(companySlice.actions.clearAll())
		}
		const res = yield* call(companyApi.getAll, requestParams)
		const companies = new ResponseCatalog<CompanyModel>(res)
		if (!clear) {
			const olderCompanies = yield* select(companySelectors.selectEntries)
			companies.entries = [...olderCompanies, ...companies.entries]
		}

		yield* put(companySlice.actions.setRequestParams(requestParams))
		yield* put(companySlice.actions.setAll(companies))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* companySaga() {
	yield* takeLeading(companySlice.actions.getAll, getList)
}
